import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { BookComponent } from './Book';
import { dummyData } from '../api/dummy';

const BookList = () => {
  const { setValue } = useFormContext();
  const books = dummyData;
  const [selectedBooks, setSelectedBooks] = useState([])

  useEffect(() => {
    setValue("books", selectedBooks);
    setValue("total_amount", selectedBooks.reduce((a, b) => a + b.price, 0));
  }, [selectedBooks]);

  const checkboxChange = (book) => {
    if (selectedBooks.includes(book)) {
      setSelectedBooks(selectedBooks.filter(item => item.id !== book.id))
    } else {
      setSelectedBooks([...selectedBooks, book])
    }
  }

  return (
    <>
      <h1 className="sub-title mb-5">Viltu fá eitthvað af fyrri bókum í byrjun áskriftar?</h1>
      <p>Nýir áskrifendur fá afslátt af fyrri bókunum um Ísadóru, í byrjun áskriftar. Hakaðu við þær bækur sem þú vilt fá strax, og svo færðu nýjustu bókina þegar hún kemur út.</p>
      <div className="book-container container mb-5">
        <div className="row justify-content-center">
          {books.map((item) => <BookComponent key={item.id} checkboxChange={checkboxChange} selectedBooks={selectedBooks} book={item} />)}
        </div>
      </div>
    </>
  );
};

export default BookList;